export default "__VITE_ASSET__DjvGRql7__"